import * as React from 'react';

const Footer = () => {
  return (
    <footer>
      {`© ${new Date().getFullYear()} Eugeni Prieto & Pau Guerrero`}
    </footer>
  );
};

export default Footer;
